var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3413_2169)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.7137 0.9375H39.5528C42.6594 0.9375 45.1784 3.45654 45.1784 6.56315V29.9058M11.292 23.6176V6.56315C11.292 3.45654 13.8098 0.9375 16.9176 0.9375H32.3382M11.292 27.9931V44.2587C11.292 47.3654 13.8098 49.8844 16.9176 49.8844H27.9852M21.6458 4.70256H31.0588M11.6737 8.46774H44.7961M29.9091 31.9998H20.6893C18.6191 31.9998 16.9389 30.3209 16.9389 28.2494V22.5725C16.9389 20.501 18.6191 18.8221 20.6893 18.8221H35.7798C37.8513 18.8221 39.5302 20.501 39.5302 22.5725C39.5302 28.8508 39.5653 28.5512 39.4267 29.1242M20.4422 42.3535H11.4441",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.4819 54.131L21.2581 42.906C20.4005 42.0484 20.3055 40.6907 21.0319 39.7206C21.877 38.5905 23.4959 38.4205 24.561 39.3268L27.0451 41.4421C28.2852 42.4972 30.1879 41.5796 30.1342 39.9519L30.1179 25.4102C30.1179 23.8513 31.3818 22.5874 32.942 22.5874C34.4984 22.5874 35.7661 23.8488 35.7661 25.4102V31.9997C35.7661 30.112 37.5825 28.7606 39.3827 29.2894C40.5566 29.6307 41.413 30.7146 41.413 31.9997V32.9411C41.413 30.9559 43.3944 29.6295 45.1784 30.2808C46.2848 30.6821 47.0611 31.771 47.0611 33.0074V33.8825C47.0611 32.2885 48.38 31.0034 49.9864 31.0596C51.5166 31.1134 52.708 32.4173 52.708 33.9475V39.018C52.708 39.5019 52.7005 39.9857 52.6843 40.4707M50.1052 53.9873C51.1853 50.9769 51.9179 47.9116 52.3242 44.8462M35.7657 31.9992L35.7646 35.7644M41.4126 32.9411L41.4122 35.7649M47.0607 33.8825L47.06 35.7649M48.0166 63.0622H34.8092C32.7378 63.0622 31.0588 61.3831 31.0588 59.3118V57.3998C31.0588 55.3284 32.7378 53.6494 34.8092 53.6494H48.0166C50.088 53.6494 51.767 55.3284 51.767 57.3998V59.3118C51.767 61.383 50.0878 63.0622 48.0166 63.0622Z",
    stroke: "#2C6CA0",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3413_2169"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileIcon);
export default __webpack_public_path__ + "static/media/mobile-icon.b5e388abd9406651361c1ee5be2caf72.svg";
export { ForwardRef as ReactComponent };